export const convertToDashes = (camel: string) => camel.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`);
